import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, vModelRadio as _vModelRadio, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24d269c0")

_pushScopeId("data-v-24d269c0")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-header-title" }, [
    /*#__PURE__*/_createVNode("p", { class: "title is-4" }, "Allgemeine Hinweise zur Abholung")
  ])
], -1)
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "subtitle is-5" }, "Die Abholung ist spätestens 24 h vor Abnahme anzumelden. Alle untenstehenden Felder sind auszufüllen.", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Bei Abholung der Ware an unserem Lager ist folgendes zu beachten:", -1)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/_createVNode("li", null, "Zuständiges Zollamt ist HZA Hamburg Hafen (DE004851), Abf. Windhukkai oder Abf. Waltershof", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("li", null, "Bitte beachten Sie, dass wir Sendungen nur ausliefern, sofern unsere Verwahrung nachweislich beendet wurde. Anderenfalls erhält Ihr Fahrer die Ware nicht!", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Für die Abholung ist eine Zeitfenster-Buchung über ")
const _hoisted_11 = /*#__PURE__*/_createVNode("a", {
  href: "https://www.cargoclix.com/kn-hamburg",
  target: "_blank"
}, "Cargoclix", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" erforderlich!")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "subtitle is-6" }, "Für Kosten jeder Art, welche durch falsche oder fehlende Eingaben bzw. durch die Verwendung einer falschen ATB Nr. verursacht werden, haftet ausschließlich der Verursacher!", -1)
const _hoisted_15 = {
  key: 0,
  class: "message is-warning"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "message-header" }, [
  /*#__PURE__*/_createVNode("p", null, "Achtung")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "message-body" }, " Anmeldung konnte nicht gesendet werden. Bitte versuche Sie es später noch einmal. ", -1)
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Firma", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "help is-danger is-hidden" }, null, -1)
const _hoisted_21 = { class: "field is-grouped" }
const _hoisted_22 = { class: "field-body" }
const _hoisted_23 = { class: "field" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Name", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "help is-danger is-hidden" }, null, -1)
const _hoisted_26 = { class: "field" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Telefonnummer", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("p", {
  class: "help is-danger is-hidden",
  style: {"max-width":"18rem"}
}, null, -1)
const _hoisted_29 = { class: "field is-grouped" }
const _hoisted_30 = { class: "control is-expanded" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Email", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "help is-danger is-hidden" }, null, -1)
const _hoisted_33 = { class: "control" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Kopie?", -1)
const _hoisted_35 = { class: "radio p-2" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Yes ")
const _hoisted_37 = { class: "radio" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("No ")
const _hoisted_39 = { class: "field is-grouped" }
const _hoisted_40 = { class: "field-body" }
const _hoisted_41 = { class: "field" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Abnahmedatum", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("p", { class: "help is-danger is-hidden" }, null, -1)
const _hoisted_44 = { class: "field" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { class: "label" }, "KFZ Kennzeichen", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "help is-danger is-hidden" }, null, -1)
const _hoisted_47 = { class: "field url-input" }
const _hoisted_48 = { class: "field" }
const _hoisted_49 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Url", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("p", { class: "help is-danger is-hidden" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "field is-grouped is-grouped-right" }, [
  /*#__PURE__*/_createVNode("div", { class: "control" }, [
    /*#__PURE__*/_createVNode("input", {
      class: "button is-primary",
      type: "submit",
      value: "Send"
    })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("ul", null, [
          _hoisted_7,
          _hoisted_8,
          (_ctx.cfs !== 'KUEHDEHAM2')
            ? (_openBlock(), _createBlock("li", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          (_ctx.cfs === 'KUEHDEHAM2')
            ? (_openBlock(), _createBlock("li", _hoisted_13, "Für die Abholung ist eine Kopie des Lagerscheins vorzulegen"))
            : _createCommentVNode("", true)
        ]),
        _hoisted_14,
        (_ctx.error.transfer)
          ? (_openBlock(), _createBlock("article", _hoisted_15, [
              _hoisted_16,
              _hoisted_17
            ]))
          : _createCommentVNode("", true),
        _createVNode("form", {
          ref: "form",
          onSubmit: [
            _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
            _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          ]
        }, [
          _createVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createVNode("input", {
              type: "text",
              class: "input",
              minlength: "3",
              maxlength: "30",
              title: "Firma",
              pattern: "^[0-9a-zA-ZßäüöÄÖÜ ,.'$&+)(\\[\\]-]+$",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.company = $event)),
              onInvalid: [
                _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args)))
              ],
              onValid: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args))),
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args))),
              required: ""
            }, null, 544), [
              [_vModelText, _ctx.company]
            ]),
            _hoisted_20
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "input",
                  minlength: "3",
                  maxlength: "25",
                  pattern: "^[a-zA-ZßäüöÄÖÜ ,.'-]+$",
                  title: "Name",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.name = $event)),
                  onInvalid: [
                    _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
                    _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args)))
                  ],
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.name]
                ]),
                _hoisted_25
              ]),
              _createVNode("div", _hoisted_26, [
                _hoisted_27,
                _withDirectives(_createVNode("input", {
                  type: "tel",
                  class: "input",
                  name: "phone",
                  pattern: "^\\+?[0-9 -/]+$",
                  minlength: "5",
                  maxlength: "20",
                  title: "Telefonnumer",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.phone = $event)),
                  onInvalid: [
                    _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"])),
                    _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args)))
                  ],
                  onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.phone]
                ]),
                _hoisted_28
              ])
            ])
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _hoisted_31,
              _withDirectives(_createVNode("input", {
                type: "email",
                name: "email",
                class: "input",
                minlength: "6",
                maxlength: "70",
                title: "Email",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.email = $event)),
                onInvalid: [
                  _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent"])),
                  _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args)))
                ],
                onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args))),
                required: ""
              }, null, 544), [
                [_vModelText, _ctx.email]
              ]),
              _hoisted_32
            ]),
            _createVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode("label", _hoisted_35, [
                _withDirectives(_createVNode("input", {
                  type: "radio",
                  name: "copy",
                  value: "true",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.copy = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.copy]
                ]),
                _hoisted_36
              ]),
              _createVNode("label", _hoisted_37, [
                _withDirectives(_createVNode("input", {
                  type: "radio",
                  name: "copy",
                  value: "false",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.copy = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.copy]
                ]),
                _hoisted_38
              ])
            ])
          ]),
          _createVNode("div", _hoisted_39, [
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, [
                _hoisted_42,
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "input",
                  name: "pickup",
                  title: "Abnahmedatum",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.pickup = $event)),
                  onInvalid: [
                    _cache[21] || (_cache[21] = _withModifiers(() => {}, ["prevent"])),
                    _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args)))
                  ],
                  onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args))),
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.pickup]
                ]),
                _hoisted_43
              ]),
              _createVNode("div", _hoisted_44, [
                _hoisted_45,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "input",
                  name: "crn",
                  maxlength: "10",
                  pattern: "^[A-Z0-9 -]+$",
                  title: "Kfz-Kennzeichen",
                  onInvalid: [
                    _cache[24] || (_cache[24] = _withModifiers(() => {}, ["prevent"])),
                    _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args)))
                  ],
                  onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args))),
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.crn = $event))
                }, null, 544), [
                  [_vModelText, _ctx.crn]
                ]),
                _hoisted_46
              ])
            ])
          ]),
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _hoisted_49,
              _withDirectives(_createVNode("input", {
                type: "text",
                autocomplete: "off",
                name: "url",
                class: "input",
                maxlength: "10",
                pattern: "^[A-Z0-9 -]+$",
                title: "URL",
                onInvalid: [
                  _cache[28] || (_cache[28] = _withModifiers(() => {}, ["prevent"])),
                  _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args)))
                ],
                onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.validateField && _ctx.validateField(...args))),
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.url = $event))
              }, null, 544), [
                [_vModelText, _ctx.url]
              ]),
              _hoisted_50
            ])
          ]),
          _hoisted_51
        ], 544)
      ])
    ])
  ]))
})